import { STORY_DIRECTIONS, STORY_EMOTES } from '@rdd/contracts'
import { z } from 'zod'

/**
 * As mensagens da sala do mundo, do lado do cliente (docs/05 secao 10). Validadas na chegada: o servidor e a
 * autoridade, mas uma mensagem fora do formato e defeito, e ela nao pode virar `undefined` na tela.
 */

export const publicPlayerSchema = z.object({
  id: z.string(),
  nick: z.string(),
  character: z.string().nullable(),
  x: z.number().int(),
  y: z.number().int(),
  dir: z.enum(STORY_DIRECTIONS),
  status: z.enum(['idle', 'walking', 'dueling']),
})
export type PublicPlayer = z.infer<typeof publicPlayerSchema>

export const snapshotSchema = z.object({ you: z.string(), mapId: z.string(), players: z.array(publicPlayerSchema) })
export type Snapshot = z.infer<typeof snapshotSchema>

export const deltaSchema = z.object({ upserts: z.array(publicPlayerSchema), removed: z.array(z.string()) })
export type Delta = z.infer<typeof deltaSchema>

export const emoteSchema = z.object({ playerId: z.string(), emoteId: z.enum(STORY_EMOTES) })
export type EmoteMessage = z.infer<typeof emoteSchema>

/** A resposta de `POST /story/world/join` (modo_historia/04#API-002). */
export const joinSchema = z.object({
  roomId: z.string().min(1),
  endpoint: z.string().min(1),
  seatToken: z.string().min(1),
  mapId: z.string().min(1),
  userId: z.string().min(1),
  spawn: z.object({ x: z.number().int(), y: z.number().int() }),
  /** O duelo contra NPC que acabou de terminar (docs/21 secao 13), para a fala de vitoria ou derrota. */
  npcOutcome: z.object({ botId: z.string(), won: z.boolean() }).nullable().default(null),
})
export type WorldJoin = z.infer<typeof joinSchema>

const who = z.object({ id: z.string(), nick: z.string() })

/** O desafio recebido (docs/05 secao 10.3). */
export const challengedSchema = z.object({ challengeId: z.string(), from: who, expiresAt: z.number() })
export type Challenged = z.infer<typeof challengedSchema>

/** O desafio enviado, esperando resposta. */
export const challengePendingSchema = z.object({ challengeId: z.string(), to: who, expiresAt: z.number() })
export type ChallengePending = z.infer<typeof challengePendingSchema>

/** O desafio fechou sem duelo. `challengeId` nulo e o desafio que nem chegou a abrir. */
export const challengeClosedSchema = z.object({
  challengeId: z.string().nullable(),
  reason: z.string(),
  about: z.string().optional(),
})
export type ChallengeClosed = z.infer<typeof challengeClosedSchema>

/** A passagem por um portal foi aceita (docs/21 secao 5): o cliente refaz a entrada, que cai no mapa novo. */
export const travelSchema = z.object({ mapId: z.string().min(1) })

/** O pedido de duelo a um NPC nao virou duelo (docs/21 secao 13): o motivo, para a tela. */
export const npcDuelClosedSchema = z.object({ npcId: z.string(), reason: z.string() })

/** O duelo do desafio aceito esta pronto: o cliente sai do mundo e vai a ele, no `web2`. */
export const duelReadySchema = z.object({ duelId: z.string().min(1) })
